<template>
  <div>
    <headNav></headNav>
    <!--          测试高德地图-->
    <div class="row" style="margin-top: 70px;margin-bottom: 20px;">
      <div class="col-md-10 col-md-offset-1" id="container"></div>
    </div>
     <Base></Base>
  </div>

</template>

<script>
import MapLoader from '../../plugins/amap.js'
export default {
  mounted: function () {
    let that = this
    MapLoader().then(AMap => {
      console.log('地图加载成功')
      that.map = new AMap.Map("container", {
        resizeEnable: true,
        zoom:18,
        center:[113.627295,34.683182],
      });
      AMap.plugin(['AMap.ToolBar','AMap.Scale'],function(){//异步同时加载多个插件
            var toolbar = new AMap.ToolBar();
            that.map.addControl(toolbar);
            var scale = new AMap.Scale();
            that.map.addControl(scale);
        });
      var marker = new AMap.Marker({
             position:[113.627295,34.683182],
             title: '河南威盾保安服务有限公司'//位置
         })
      that.map.add(marker);//添加到地图
    }, e => {
      console.log('地图加载失败' ,e)
    })

  },
  methods: {


  }
}
</script>

<style scoped>
#container{
  height: 500px;

}
.row{
    margin-left: 0px;
    margin-right: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/lxwm.vue